import React from 'react';
import { Button } from '@themesberg/react-bootstrap';
import { useResponsive } from '../hooks/useResponsive';

const ResponsiveButton = ({ 
  children, 
  variant = 'primary',
  size = 'sm',
  className = '',
  mobileFullWidth = true,
  ...props 
}) => {
  const { isMobile } = useResponsive();
  
  const buttonClass = `
    ${className} 
    ${isMobile ? 'btn-mobile' : ''} 
    ${isMobile && mobileFullWidth ? 'w-100' : ''}
  `.trim();
  
  const buttonSize = isMobile ? 'lg' : size;
  
  return (
    <Button
      variant={variant}
      size={buttonSize}
      className={buttonClass}
      style={{
        minHeight: isMobile ? '48px' : 'auto',
        fontSize: isMobile ? '1rem' : '0.875rem',
        fontWeight: isMobile ? '500' : '400',
        marginBottom: isMobile && mobileFullWidth ? '0.5rem' : '0'
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ResponsiveButton;